module.exports = __webpack_public_path__ + "static/media/7.48c27538.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/7.png
// module id = 786
// module chunks = 0